var e=function(e,t){var n=document.createElement("canvas").getContext("2d");return n?(n.font=t.weight+" "+t.size+"px "+t.family,n.measureText(e).width):0};export{e as getTextWidth};
